import React, { useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadTestQuestionsAsync, selectTestQuestions } from '../dashboardSlice';
import { ChartCard } from './ChartCard';
import { useThemeVersion, getStoredColorMode } from '../../../useTheme';
import { categoryColor } from '../categoryColors';

export const TestQuestionsChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectTestQuestions);
    // getComputedStyle abaixo só lê o CSS de novo se essa memo recalcular —
    // sem isso, trocar de tema depois de montado deixa a cor antiga presa.
    const themeVersion = useThemeVersion();

    const chartOptions = useMemo(() => ({
        plugins: {
            legend: {
                labels: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            },
            x: {
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [themeVersion]);

    const prepareData = () => {
        const color = categoryColor('test', getStoredColorMode());
        if (!Array.isArray(data) || !data.length) {
            return {
                labels: [],
                datasets: [{
                    label: 'Questões por prova',
                    data: [],
                    backgroundColor: color
                }]
            };
        }

        return {
            labels: data.map(item => item.testTitle),
            datasets: [{
                label: 'Questões por prova',
                data: data.map(item => item.questionCount),
                backgroundColor: color
            }]
        };
    };

    return (
        <ChartCard
            title="Questões por prova"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadTestQuestionsAsync())}
        >
            <div style={{ minHeight: '200px' }}>
                <Chart type="bar" data={prepareData()} options={chartOptions} />
            </div>
        </ChartCard>
    );
}; 